<script lang="ts">
	/**
	 * @typedef {Object} Props
	 * @property {import('svelte').Snippet} [children]
	 */
	type Props = {
		onclick?: ((event: MouseEvent) => void) | null
		children?: import('svelte').Snippet | null
	}
	/** @type {Props} */
	let { children, onclick }: Props = $props()
</script>

<button type="button" class="button" {onclick}>
	{@render children?.()}
</button>

<style>
	.button {
		@apply bg-se-green-1 text-white border-se-green-2;
		border-radius: 4px;
		transition: 0.2s ease all;
		padding: 6px 10px;
	}

	.button:hover {
		@apply bg-se-green-2 border-se-green-2;
	}
</style>
